<script setup lang="ts">
import { Dayjs } from 'dayjs'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

import { ChartUnit } from './types'
import VolumeGraphics from './VolumeGraphics.vue'

export interface NewCodingStaysStatsProps {
  earlyLimit: Dayjs
  lateLimit: Dayjs
  chartUnit: ChartUnit
  selectedMedicalUnits: number[] | null
  labelSets: string[]
}

const store = useStore()

const props = withDefaults(
  defineProps<NewCodingStaysStatsProps>(),
  {
    chartUnit: ChartUnit.MONTH,
    selectedMedicalUnits: () => [],
    labelSets: () => []
  }
)

const stats = computed(() =>
  store.state.stats.newCodingStaysStats
)
const statsPercent = computed(() =>
  store.state.stats.newCodingStaysStats.map((s) => {
    return {
      prctOpenedStay: s.countStay > 0 ? ((s.countNewCodingOpenedStay / s.countStay) * 100.0).toFixed(2) : 0,
      prctValidatedStay: s.countStay > 0 ? ((s.countNewCodingValidatedStay / s.countStay) * 100.0).toFixed(2) : 0,
      prctEditedStay: s.countStay > 0 ? ((s.countNewCodingEditedStay / s.countStay) * 100.0).toFixed(2) : 0,
    }
  })
)

watch(() => props, () => {
  refresh()
}, { immediate: true })

function refresh() {
  store.dispatch('getNewCodingStaysStats', {
    earlyLimit: props.earlyLimit.format('YYYY-MM-DD'),
    lateLimit: props.lateLimit.format('YYYY-MM-DD'),
    unit: props.chartUnit,
    medicalUnits: props.selectedMedicalUnits,

  })
}
</script>

<template>
  <div class="stat">
    <h1 class="stat-title">
      Primo-codage
    </h1>
    <volume-graphics
      :label-sets="labelSets"
      :stats="stats"
      :stats-percent="statsPercent"
      :prct-infos="{
        prctOpenedStay: { label: 'Consulté', unit: '%' },
        prctEditedStay: { label: 'Validé (avec modification)', unit: '%' },
        prctValidatedStay: { label: 'Validé (total)', unit: '%' },
      }"
      :stats-infos="{
        countStay: { label: 'Primo-codage', unit: 'séjour(s)' },
        countNewCodingOpenedStay: { label: 'Consultés', unit: 'séjour(s)'},
        countNewCodingValidatedStay: { label: 'Validés (total)', unit: 'séjour(s)' },
        countNewCodingEditedStay: { label: 'Validés (avec modification)', unit: 'séjour(s)' },
      }"
    />
  </div>
</template>
